import { render, staticRenderFns } from "./ModalDisplayComponent.vue?vue&type=template&id=351f115e"
import script from "./ModalDisplayComponent.vue?vue&type=script&lang=js"
export * from "./ModalDisplayComponent.vue?vue&type=script&lang=js"
import style0 from "./ModalDisplayComponent.vue?vue&type=style&index=0&id=351f115e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports